import { render, staticRenderFns } from "./DashboardDescription.vue?vue&type=template&id=40148b68&scoped=true&"
import script from "./DashboardDescription.vue?vue&type=script&lang=js&"
export * from "./DashboardDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40148b68",
  null
  
)

export default component.exports